export const column = [
  { key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 50 },
  { key: '2', headerName: 'Outlet Name', field: 'outlet_name', hide: false, width: 260 },
  { key: '3', headerName: 'Audit Number', field: 'audit_id', hide: false, width: 250 },
  { key: '4', headerName: 'Audit Date', field: 'audit_date', hide: false, width: 130 },
  { key: '5', headerName: 'Score', field: 'total_mark', hide: false, width: 100 }, 
  { key: '6', headerName: 'Agent Name', field: 'entry_by', hide: false, width: 180 }, 
  { key: '7', headerName: 'Duration Time', field: 'spent_time', hide: false, width: 150 },
 ];